import styled from 'styled-components'
import CustomTheme, { navTheme } from 'themes'

export const Container = styled.div`
  display: flex;
  width: 100vw;
  flex-direction: column;
  height: 48px;
  min-height: 48px;
  justify-content: center;
  border-bottom: 1px solid ${navTheme.colors.palette.gray[60]};

  ${CustomTheme.breakPoint.tablet} {
    min-height: 64px;
    height: 64px;
  }
`

export const LogoContainer = styled.div`
  display: flex;
  width: 46px;
  height: 16px;
  margin: 0 2rem;

  ${CustomTheme.breakPoint.tablet} {
    width: 84px;
    height: 21px;
    margin: 0 2rem;
  }

  ${CustomTheme.breakPoint.desktop} {
    width: 84px;
    height: 21px;
    margin: 0 3.25rem;
  }

  svg {
    width: 46px;
    height: 16px;

    ${CustomTheme.breakPoint.tablet} {
      width: 84px;
      height: 21px;
    }
  }
`
